import { render } from "./FixedExpenses.vue?vue&type=template&id=d9b9f3da&scoped=true"
import script from "./FixedExpenses.vue?vue&type=script&lang=js"
export * from "./FixedExpenses.vue?vue&type=script&lang=js"

import "./FixedExpenses.vue?vue&type=style&index=0&id=d9b9f3da&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b9f3da"]])

export default __exports__